<template>
    <article class="card-product">
                    <div class="content-img">
                        <router-link :to="{path: `/productos/${product.slug_product}`, query: { id: product.id}}">
                            <img :src="product.img_product[0]" :alt="product.description_product_custom" />
                        </router-link>
                    </div>
                    <div class="content-text">
                        <div class="text">
                            <p class="name-product">{{ product.name_product }}</p>
                            <p>{{ product.description_product_custom }}</p>
                            <span class="tag-brand">{{ product.brand_product }}</span>
                        </div>
                        <button @click="() => addToCartShopping(product)" class="btn btn-add-to-cart">
                            <img src="@/assets/icons/add_circle.svg" alt="Icon add" /> &nbsp;  Agregar
                        </button> 
                    </div>
                </article>
</template>





<script lang="ts" setup>
import {defineProps } from 'vue';
import { useCartShoppingStore } from "@/store/cartshopping";

const cartShop = useCartShoppingStore();

defineProps({
    product: {
        type: Object,
        required: true
    }
})

function addToCartShopping(product) {
    // Verificar si el producto ya está en el carrito
    const existingProduct = cartShop.cart.find(item => item.id === product.id);
    if (existingProduct) {
        existingProduct.quantity += 1;
        return;
    }
    cartShop.addToCart(product);
}

</script>

<style lang="scss" scoped>

.card-product {
        display: flex;
        flex-direction: column;
        gap: 20px;
        height: 380px;
        padding-block: 20px;
        background-color: white;
        border-radius: 10px !important;
        overflow: hidden;
        box-shadow: 0px 0px 5.3px -3px rgba(34, 115, 184, 0.10);
        .content-img {
            display: flex;
            justify-content: center;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            overflow: hidden;
            img {
                width: auto;
                height: 150px;
                object-fit: cover;
            }
            &:hover {
                img {
                    transform: scale(1.2);
                    transition: all 0.3s ease-in-out;
                }
            }
        }
        
        .content-text {
            display: flex;
            flex-direction: column;
            gap: 30px;
            padding-inline: 20px;
            .text {
                display: flex;
                flex-direction: column;
                gap: 12px;
            }
            .name-product {
                font-size: 18px;
                color: $blacked;
                text-align: start;
                font-weight: 500;
            }
            p {
                color: rgba(32, 32, 32, 0.50);
                font-size: 16px;
                font-weight: 400;
                line-height: normal;
                text-align: start;
            }
            .tag-brand {
                margin-top: 15px;
                padding-block: 5px;
                padding-inline: 10px;
                border-radius: 5px;
                background-color: $tint2;
                color: $whited;
                text-align: start;
                width: fit-content;
                font-size: 14px;
            }
            .btn-add-to-cart {
                background: none;
                border: none;
                outline: none;
                color: $tint2;
                font-size: 18px;
                cursor: pointer;
                padding-block: 5px;
                &:hover {
                    background-color: $whited;
                    border-radius: 5px;
                }
            }
        }
        }
        
@media (max-width: 1300px) {
    .card-product {
        height: 350px;
        .content-img img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
        }
        
    }
}
@media (max-width: 1080px) {
    .card-product {
        .content-text {
            .name-product {
                font-size: 16px;
            }
        }
    }
}
@media (max-width: 400px) {}
</style>